exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal[data-v-3c8d27e6] {\n  z-index: 99;\n}\n.modal__title[data-v-3c8d27e6] {\n    font-size: 1.3em;\n}\n.modal .modal__close[data-v-3c8d27e6] {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-size: 24px;\n    padding: 3px 10px;\n}\n.modal[data-v-3c8d27e6] .button-actions {\n    text-align: center;\n}\n.modal[data-v-3c8d27e6] .btn-submit-button {\n    float: left;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3c8d27e6","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/noomz/Projects/Opendream/kadnud/kadnud-eef-app/src/css"],"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LoginModal.vue
// module id = 581
// module chunks = 1